import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import moment from "moment";
import SelectComponent from "../../SharedComponents/SelectComponent";
import { Form } from "react-bootstrap";
import { getIndividualTreatmentSalesReport } from "../../../apis/customTemplate";
import { toastify } from "../../../helperFunctions/toastify";
import DateInput from "../../SharedComponents/DateInput";
import { setTableSearch } from "../../../redux/slices/commonSlice";
import { getTreatments } from "../../../../src/apis/treatment";
import AsyncSelect from "../../SharedComponents/AsyncSelect";
import { getInvoiceId } from "../../../helperFunctions/utils";
import {
  customDateSort,
  downloadCsv,
  formatDate,
} from "../../../helperFunctions/utils";
import { getPatients } from "../../../apis/patients";
import {
  loadOptionPatients,
  loadSelectedPatient,
  getPatientDetailsById,
} from "../../../apis/patients";
const FilterWrapper = styled.div`
  label {
    color: inherit;
  }

  .btn-wrapper {
    align-items: center;
    display: flex;
    margin-top: 20px;
  }
`;

function IndividualTreatmentSalesReport() {
  const numberFormatter = Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const buttonRef = useRef(null);
  const pathname = location.pathname;
  const fieldPathname = pathname.replace("/", "");

  const { tableSearch } = useSelector((state) => state.commonData);

  const [filteredData, setFilteredData] = useState([]);
  const [patients, setPatients] = useState([]);
  const [selectedPatient, setPatient] = useState([]);
  const [refundList, setRefundList] = useState([]);
  const [startDate, setStartDate] = useState(
    tableSearch[fieldPathname]?.individualTreatment?.startDate
      ? tableSearch[fieldPathname]?.individualTreatment?.startDate
      : `${new Date().getFullYear()}-01-01`
  );
  const [endDate, setEndDate] = useState(
    tableSearch[fieldPathname]?.individualTreatment?.endDate
      ? tableSearch[fieldPathname]?.individualTreatment?.endDate
      : `${new Date().getFullYear()}-12-29`
  );
  const [refetch, setRefetch] = useState(false);

  const onReduxFilter = (valueStartDate, valueEndDate, valuePatient) => {
    dispatch(
      setTableSearch({
        ...tableSearch,
        [fieldPathname]: {
          ...tableSearch[fieldPathname],
          individualTreatment: {
            startDate: valueStartDate,
            endDate: valueEndDate,
            selectedPatient: valuePatient
          },
        },
      })
    );
  };

  // useEffect(() => {
  //   (async () => {
  //     const response = await getPatients();
  //     if (response?.status !== "Fail") {
  //       setPatients(response);
  //     } else {
  //       toastify("Failed to get patients", "error");
  //     }
  //   })();
  // }, []);

  useEffect(() => {
    setStartDate(
      tableSearch[fieldPathname]?.individualTreatment?.startDate
        ? tableSearch[fieldPathname]?.individualTreatment?.startDate
        : `${new Date().getFullYear()}-01-01`
    );
    setEndDate(
      tableSearch[fieldPathname]?.individualTreatment?.endDate
        ? tableSearch[fieldPathname]?.individualTreatment?.endDate
        : `${new Date().getFullYear()}-12-29`
    );
    setPatient(tableSearch[fieldPathname]?.individualTreatment?.selectedPatient);

    if (
      buttonRef.current &&
      (tableSearch[fieldPathname]?.individualTreatment?.startDate &&
        tableSearch[fieldPathname]?.individualTreatment?.endDate &&
        tableSearch[fieldPathname]?.individualTreatment?.selectedPatient)
    ) {
      setTimeout(() => {
        if (buttonRef.current) {
          buttonRef.current.click();
        }
      }, [1000]);
    }
  }, []);

  const onSearch = () => {
    if (selectedPatient) {
      getIndividualTreatmentSalesReport({
        patientId: selectedPatient,
        start_date: startDate,
        end_date: endDate,
      }).then((res) => {
        console.log("res?.result?.data", res?.result?.data);
        if (res?.result?.data) {
          setRefundList(res.result.data);
          setFilteredData(res.result.data);
        }
      });
    }
  }

  // useEffect(() => {
  //   if (selectedPatient) {
  //     getIndividualTreatmentSalesReport({
  //       patientId: selectedPatient,
  //       start_date: startDate,
  //       end_date: endDate,
  //     }).then((res) => {
  //       console.log("res?.result?.data", res?.result?.data);
  //       if (res?.result?.data) {
  //         setRefundList(res.result.data);
  //         setFilteredData(res.result.data);
  //       }
  //     });
  //   }
  // }, [selectedPatient, startDate, endDate, refetch]);

  const formatValue = (value) => {
    const num = Number(value || 0);
    return num % 1 === 0 ? num.toString() : num.toFixed(2);
  };

  // eslint-disable-next-line no-sparse-arrays
  const columns = [
    {
      name: "Date",
      selector: (row) => row.created_at,
      sortable: true,
      sortFunction: (a, b) => customDateSort(a, b, "created_at"),
      cell: (row) => formatDate(row.created_at),
    },
    {
      name: "Invoice ID",
      selector: (row) => row?.invoiceNo || 0,
      cell: (row) => getInvoiceId(row?.invoiceNo),
    },
    {
      name: "Amount",
      selector: (row) => row.actualAmount,
      sortable: true,
      cell: (row) => numberFormatter.format(row.actualAmount),
    },
    {
      name: "Amount GST",
      selector: (row) => row.gst - row.actualAmount,
      sortable: true,
      cell: (row) => numberFormatter.format(row.gst - row.actualAmount),
    },
    {
      name: "Total Amount",
      selector: (row) => row.gst,
      sortable: true,
      cell: (row) => numberFormatter.format(row.gst),
    },
  ];

  const data = filteredData?.map((e, index) => {
    return {
      ...e,
      index,
      key: index,
    };
  });

  const customStyles = {
    headCells: {
      style: {
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        justifyContent: "center",
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: (row) => row,
      style: {
        borderWidth: "0px",
      },
    },
    {
      when: (row) => row.index % 2 === 1,
      style: {
        backgroundColor: "#f8f8f8",
        borderWidth: "0px",
      },
    },
  ];

  const exportCsv = () => {
    const csvData = refundList.map((row) => ({
      Date: formatDate(row.created_at),
      "Invoice ID": getInvoiceId(row?.invoiceNo),
      "Amount": numberFormatter.format(row?.actualAmount),
      "Amount GST": numberFormatter.format(row.gst - row.actualAmount),
      "Total Amount": numberFormatter.format(row.gst),
    }));

    downloadCsv(csvData, "Individual_Treatment_Report");
  };

  return (
    <div className="p-0">
      <div
        className="mainHeading"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "18px",
          }}
        >
          <FilterWrapper className="d-flex">
            <Form.Group className="me-3" style={{ width: "260px" }}>
              <Form.Label className="headings2" style={{ color: "#000" }}>
                Select Patient
              </Form.Label>
              {/* <SelectComponent
                singleSelect
                searchEnabled
                selectedValue={selectedPatient}
                onChange={(e) => {
                  setPatient(e);
                }}
                options={[
                  ...patients?.map((e) => {
                    return {
                      label: e?.name,
                      value: e,
                    };
                  }),
                ]}
              /> */}

              <AsyncSelect
                value={selectedPatient}
                setValue={(value) => {
                  setPatient(value?._id);
                }}
                loadOptions={(search, loadedOptions, { page }) =>
                  loadOptionPatients(search, loadedOptions, { page, isIndividual: true })
                }
                loadSelectedOption={loadSelectedPatient}
              />
            </Form.Group>
            <div className="me-3" style={{ width: "260px" }}>
              <DateInput
                value={startDate}
                label="Start Date"
                onChange={(e) => {
                  setStartDate(e);
                }}
              />
            </div>
            <div className="me-3" style={{ width: "260px" }}>
              <DateInput
                value={endDate}
                label="End Date"
                onChange={(e) => {
                  setEndDate(e);
                }}
              />
            </div>
            <div className="btn-wrapper">
              <Button
                ref={buttonRef}
                className="addItem me-3"
                onClick={() => {
                  if (endDate < startDate) {
                    toastify("End date is less than start date", "error");
                    return;
                  }
                  onReduxFilter(startDate, endDate, selectedPatient);
                  onSearch();
                }}
              >
                Search
              </Button>
              <Button className="addItem" onClick={() => exportCsv()}>
                Export
              </Button>
            </div>
          </FilterWrapper>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={data || []}
        pagination
        customStyles={customStyles}
        conditionalRowStyles={conditionalRowStyles}
      />
    </div>
  );
}

export default IndividualTreatmentSalesReport;
